"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Country = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const region_entity_1 = require("./region.entity");
let Country = class Country {
    constructor(name, region, isoCode) {
        this.name = name;
        this.region = region;
        this.isoCode = isoCode ?? "";
    }
};
exports.Country = Country;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Object)
], Country.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "name", type: "varchar", length: 100 }),
    tslib_1.__metadata("design:type", String)
], Country.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "iso_code", type: "varchar", length: 10, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Country.prototype, "isoCode", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => region_entity_1.Region, (region) => region.id),
    (0, typeorm_1.JoinColumn)({ name: "region_id" }) // Ensure the correct column name is used
    ,
    tslib_1.__metadata("design:type", typeof (_b = typeof region_entity_1.Region !== "undefined" && region_entity_1.Region) === "function" ? _b : Object)
], Country.prototype, "region", void 0);
exports.Country = Country = tslib_1.__decorate([
    (0, typeorm_1.Entity)("country"),
    tslib_1.__metadata("design:paramtypes", [String, typeof (_a = typeof region_entity_1.Region !== "undefined" && region_entity_1.Region) === "function" ? _a : Object, String])
], Country);
